/**
 * API URL 配置管理
 * 統一管理所有 API 相關的 URL 配置
 */

/**
 * 獲取基礎 API URL
 * @returns {string} API 基礎 URL
 */
export function getApiBaseUrl() {
  return process.env.VUE_APP_API_BASE_URL;
}

/**
 * 獲取團隊 API 基礎 URL
 * @returns {string} 團隊 API 基礎 URL
 */
export function getTeamApiBaseUrl() {
  return process.env.VUE_APP_TEAM_API_BASE_URL;
}

/**
 * 獲取網站基礎 URL
 * @returns {string} 網站基礎 URL
 */
export function getWebBaseUrl() {
  return process.env.VUE_APP_WEB_BASE_URL;
}

/**
 * API 端點配置
 * 使用函數來動態獲取，確保環境變數正確載入
 */
export const API_ENDPOINTS = {
  // 用戶登錄相關
  get USER_LOGIN_WEB() {
    return `${getTeamApiBaseUrl()}/user/login/web`;
  },

  // 文件上傳相關
  get UPLOAD_VIDEO() {
    return `${getTeamApiBaseUrl()}/api/upload/video`;
  },
  get UPLOAD_IMAGE() {
    return `${getTeamApiBaseUrl()}/api/upload/image`;
  },

  // 下載相關
  get MATERIAL_DOWNLOAD() {
    return `${getTeamApiBaseUrl()}/api/group/material_download`;
  },

  // 支付相關
  get PAY_SUBMIT() {
    return `${getTeamApiBaseUrl()}/web/pay/submit`;
  },

  // 其他
  get INDEX_HTML() {
    return `${getTeamApiBaseUrl()}/index.html`;
  },
  get WEB_UPLOADS() {
    return `${getTeamApiBaseUrl()}/web/uploads`;
  },
};

/**
 * 構建完整的 URL
 * @param {string} endpoint - API 端點
 * @param {object} params - URL 參數
 * @returns {string} 完整的 URL
 */
export function buildUrl(endpoint, params = {}) {
  let url = endpoint;

  if (Object.keys(params).length > 0) {
    const searchParams = new URLSearchParams(params);
    url += `?${searchParams.toString()}`;
  }

  return url;
}

/**
 * 構建支付 URL
 * @param {string} orderNo 訂單號
 * @returns {string} 完整的支付 URL
 */
export function buildPayUrl(orderNo) {
  return `${getTeamApiBaseUrl()}/web/pay/submit?order_no=${orderNo}`;
}

/**
 * 構建用戶登錄 URL
 * @param {string} businessNumber 企業編號
 * @param {string} token 用戶 token
 * @returns {string} 完整的登錄 URL
 */
export function buildUserLoginUrl(businessNumber, token) {
  return `${getTeamApiBaseUrl()}/user/login/web?business_number=${businessNumber}&token=${token}`;
}

/**
 * 構建材料下載 URL
 * @param {string} params 下載參數
 * @returns {string} 完整的下載 URL
 */
export function buildMaterialDownloadUrl(params = "") {
  return `${getTeamApiBaseUrl()}/api/group/material_download${
    params ? "?" + params : ""
  }`;
}

/**
 * 構建 Web 上傳文件 URL
 * @param {string} path 文件路徑
 * @returns {string} 完整的文件 URL
 */
export function buildWebUploadsUrl(path) {
  return `${getTeamApiBaseUrl()}/web/uploads/${path}`;
}
